import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import '../assets/css/inclusion.css';
import { nsOptions } from '../i18n';
import NewModal from './NewModal';
import Help from './Help';
import FAQLink from './FAQLink';
import TreeViewSelector from './TreeViewSelector';

/**
 * Modal wrapper for configuring inclusion duplication.
 * Uses the reusable TreeViewSelector component for variable selection.
 */
class DuplicationTreeViewModal extends Component {
  handleSave = () => {
    const { onSave } = this.props;
    if (this.treeViewRef) {
      onSave(this.treeViewRef.getSelectedIds());
    }
    if (this.modalRef) this.modalRef.hide();
  };

  handleCancel = () => {
    if (this.modalRef) this.modalRef.hide();
  };

  handleLoad = async () => {
    const { onLoad } = this.props;
    if (onLoad) {
      await onLoad();
    }
    if (this.treeViewRef) {
      this.treeViewRef.resetState();
    }
  };

  render() {
    const {
      t, projectPages, projectElements, elements,
      initialSelectedIds, children,
    } = this.props;

    return (
      <NewModal
        ref={(ref) => { this.modalRef = ref; }}
        noHeader
        keyboard={false}
        trigger={children}
        size="lg"
        onLoad={this.handleLoad}
        extraClass="duplication-modal"
        modalBodyClassName="p-0"
      >
        <div
          className="d-flex align-items-center justify-content-between px-4 py-3"
          style={{ background: 'var(--newblue-1)' }}
        >
          <div className="d-flex align-items-center">
            <h5 className="text-white mb-0">
              {t('project:duplication.modal-title')}
            </h5>
            <Help
              tooltipPlacement="bottom"
              iconClassName="ml-2"
              iconColor="text-white"
              interactive
            >
              {t('project:duplication.enable-tooltip')}
              <br />
              <FAQLink
                articleId={16}
                text="project:duplication.help-link"
                linkClassName="classical-link text-newblue-1"
              />
            </Help>
          </div>
        </div>
        <div className="px-4 pt-3 pb-1">
          <p className="mb-3">{t('project:duplication.instruction')}</p>
          <TreeViewSelector
            ref={(ref) => { this.treeViewRef = ref; }}
            t={t}
            projectPages={projectPages}
            projectElements={projectElements}
            elements={elements}
            initialSelectedIds={initialSelectedIds}
            idPrefix="dup"
          />
        </div>
        <div className="d-flex justify-content-end align-items-center px-4 py-3 pr-5 pb-4">
          <button
            type="button"
            className="btn btn-link mr-3"
            onClick={this.handleCancel}
          >
            {t('common:button.cancel')}
          </button>
          <button
            type="button"
            className="btn btn-newblue-1 text-white px-3 duplication-save-btn"
            onClick={this.handleSave}
          >
            {t('common:button.validate')}
          </button>
        </div>
      </NewModal>
    );
  }
}

DuplicationTreeViewModal.propTypes = {
  t: PropTypes.func.isRequired,
  projectPages: PropTypes.arrayOf(PropTypes.object).isRequired,
  projectElements: PropTypes.arrayOf(PropTypes.object).isRequired,
  elements: PropTypes.objectOf(PropTypes.object).isRequired,
  initialSelectedIds: PropTypes.arrayOf(PropTypes.number),
  onLoad: PropTypes.func,
  onSave: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
};

DuplicationTreeViewModal.defaultProps = {
  initialSelectedIds: [],
  onLoad: null,
};

export default withTranslation(nsOptions.ns, nsOptions)(DuplicationTreeViewModal);
